// extracted by mini-css-extract-plugin
module.exports = {"rightColumnTab":"rightColumnTab-3EeCGHSj","current":"current-39dlVAne","nbaT":"nbaT-YN9pE5nI"};